import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import "./footer.css";
import logo from "../Assets/For Footer Logo.png";
import blogImg from "../Assets/footer-checkup.png";
import newborn from "../Assets/newborn.png";
import { FaMapMarkerAlt, FaRegCalendar } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Nav from "../Section/Nav";
import { Navigate } from "react-router-dom";
import axiosConfig from "../../Service/AxiosConfig"
const Footer = ({ }) => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosConfig.get("/blogapp/blog/?&page_size=4");
        let data = res.data.results;
        setBlogs(data);

      }
      catch (error) {
        console.log(error);
      }

    }
    fetchData();
  }, []);
  console.log(blogs, "blogs");

  const navigate = useNavigate();
  return (
    <div>
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>
          {/* <p>
            Subscribe to our newsletter today to receive latest news,
            administrate cost effective for tactical data.
          </p> */}
          <div className="footer-contact">
            <p>
              <FaMapMarkerAlt /> 8–50/11, Dammaiguda Rd, near ECIL, Narayana
              Puri Colony, Sai Priya Colony, Sainikpuri, Secunderabad, Telangana
              500083
            </p>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <a href="/about" target="_top">
              <li>About Us</li>
            </a>
            <li>Our Services</li>
            <a href="/blog" target="_top">
              <li>Latest Blog</li>
            </a>

            <li
              onClick={() =>
                navigate('./', { state: { scrollTo: 'appointment-section' } })
              }
              style={{ cursor: 'pointer' }}
            >
              Appointment
            </li>
            <a href="/contact" target="_top">
              <li>Contact Us</li>
            </a>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Popular Service</h3>
          <ul>
            <li>Cardiology Care</li>
            <li>Urgent Care</li>
            <li>Orthopedic Care</li>
            <li>Diagnosis Department</li>
            <li>Gastroenterology</li>
            <li>Therapy Department</li>
            <li>Dental Service</li>
          </ul>
        </div>

        <div className="footer-section recent-posts">
          <h3>Recent Blog Posts</h3>

          {blogs?.slice(0, 2).map((blog, index) => (
            <div
              className="post"
              key={index}
              onClick={() => navigate(`/${blog.slug}/`)}
              style={{ cursor: 'pointer' }}

            >
              <img src={blog.image?.image} alt="Blog" />
              <div>
                <p className="title">{blog.title}</p>
                <p className="date">
                  <FaRegCalendar className="icon-foot" /> {blog.image?.active_from?.slice(0, 10)}
                </p>
              </div>
            </div>
          ))}


        </div>
      </div>

    </footer>
      <div className="footer-bottom">
        <div>Copyright © {new Date().getFullYear()} Shriadithyahospitals. All Rights Reserved.</div>
        <div className="footer-images">
          <a href="https://krisantec.com" target="_blank">
            Powered by KriSanTec Solutions Pvt Ltd
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
